import React from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import LeftArrow from "@svg/LeftArrow";
import { useRiddlesNavigation } from "../RamadanRiddlesContext";
import Button from "@elements/button";

const RamadanRiddlesEidView: React.FC = () => {
    const t = useTranslations();
    const { closeDrawer } = useRiddlesNavigation();
    const { setView } = useRiddlesNavigation();

    return (
        <div className="relative flex h-full flex-col bg-[#F6EAD5]">
            <button
                type="button"
                onClick={closeDrawer}
                className="absolute left-6 top-6 text-[#38190D]"
                aria-label={t("Back")}
            >
                <LeftArrow />
            </button>
            <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 text-center">
                <h2 className="text-3xl font-extrabold uppercase text-[#38190D]">
                    {t("EID mubarak")}
                </h2>
                <Image
                    src="/svgs/Hillal-and-gifts.webp"
                    alt=""
                    aria-hidden="true"
                    width={280}
                    height={280}
                    sizes="280px"
                    className="h-auto w-[280px]"
                />
                <p className="whitespace-pre-line text-xl font-extrabold uppercase text-[#38190D]">
                    {t("Ramadan Delights has ended\nSee you next year")}
                </p>

                <Button
                    className="mt-7 h-12 w-full rounded-full bg-[#F27D23] font-bold uppercase text-white outline-none border-none"
                    onClick={() => setView("rewards")}
                >
                    {t("View Rewards")}
                </Button>
            </div>
        </div>
    );
};

export default RamadanRiddlesEidView;
